module.exports = __webpack_public_path__ + "static/media/bp-top.03850bf2.png";